import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import { Page } from "@components/Page"
import { TileGrid } from "@components/tile-grid"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { RouteIcon } from "@/routes/-components/navigation-tree/route-icon"
import { Text } from "@mantine/core"
import { InfoAlert } from "@components/info-alert"
import { mapNodeIdToTranslation } from "@/routes/-components/navigation-tree/mapNodeIdToTranslation"
import { DashboardCard } from "../-components/DashboardCard"

export const Route = createFileRoute("/app/duties/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation("app_server")
  const navigate = useNavigate()

  const childrenToRender = useSuspenseQueryGet(
    "/api/NavigationTree/GetNavigationInfo",
    null
  ).data.navTree.find((x) => x.value === "DutyScheduling")?.children

  return (
    <Page titleGroupProps={{ style: { justifyContent: "flex-start" } }}>
      {childrenToRender?.length ? (
        <TileGrid
          tileData={childrenToRender}
          renderTile={({ tileData }) => (
            <DashboardCard
              mih="30vh"
              key={tileData.nodeProps.nodeId}
              stackProps={{ justify: "center", align: "center" }}
              onClick={() => navigate({ to: tileData.nodeProps.route })}
            >
              <RouteIcon
                nodeId={tileData.nodeProps.nodeId}
                size={100}
                stroke={1}
              />
              <Text style={{ textAlign: "center" }}>
                {t(mapNodeIdToTranslation(tileData.nodeProps.nodeId))}
              </Text>
            </DashboardCard>
          )}
        />
      ) : (
        <InfoAlert>{t("NoTiles")}</InfoAlert>
      )}
    </Page>
  )
}
